import React, { useState } from "react";
import EditOrAddEPF from "../EditOrAddEPFModal/EditOrAddEPF";
import { useGetEmployeePFDetails } from "../../../queries/employeeQueries";
import { useSelector } from "react-redux";
import userRoleAuth from "../../../utils/userRoleAuth/userRoleAuth";
import userRoles from "../../../config/userRoles";

const EmployeePFInfo = ({ employee }) => {
  const [openModal, setOpenModel] = useState(false);
  const onOpenModal = () => setOpenModel(true);
  const onCloseModal = () => setOpenModel(false);

  const { data: pfData } = useGetEmployeePFDetails({
    employee_id: employee?.employee_id,
  });
  const pfDetails = pfData?.data?.[0] || {};

  const loggedInUser = useSelector((state) => state.user.auth);
  const isHr = userRoleAuth(loggedInUser, userRoles.HR);
  const isAdmin = userRoleAuth(loggedInUser, userRoles.TENANTADMIN);
  const isFinanceAdmin = userRoleAuth(loggedInUser, userRoles.FINANCEADMIN);
  const isAdminOrHROrFinanceAdmin = isHr || isAdmin;

  return (
    <div className="bg-white px-8 py-6 rounded-md border border-gray-100 shadow-md shadow-[#F3F4F6] mt-6 mb-5">
      <div className="flex items-center justify-between pb-3">
        <div className="flex items-center gap-3">
          <img src="/images/basic-info-icon.svg" alt="" />
          <p className="text-base text-[#1F2937] font-semibold">
            Employees Provident Fund (EPF)
          </p>
        </div>
        {isAdminOrHROrFinanceAdmin && (
          <div className="cursor-pointer">
            <img src="/images/editicon.svg" alt="" onClick={onOpenModal} />
            <EditOrAddEPF
              openModal={openModal}
              onCloseModal={onCloseModal}
              employee={employee}
              pfDetails={pfDetails}
            />
          </div>
        )}
      </div>

      <div className="employee-info-card w-full">
        <table className="w-full border-0 table-fixed">
          <tbody>
          
            <tr className="align-top">
              <td className="title py-2 pr-4 min-w-[180px] text-gray-700 font-medium">
                PF Account Number
              </td>
              <td className="data py-2">
                {pfDetails?.pf_account_number || "N/A"}
              </td>
            </tr>
            <tr className="align-top">
              <td className="title py-2 pr-4 min-w-[180px] text-gray-700 font-medium">
                UAN
              </td>
              <td className="data py-2">{pfDetails?.uan || "N/A"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeePFInfo;
